export var AvailableDevicesValueTypes;
(function (AvailableDevicesValueTypes) {
    AvailableDevicesValueTypes[AvailableDevicesValueTypes["LUX"] = 1] = "LUX";
    AvailableDevicesValueTypes[AvailableDevicesValueTypes["EXACT"] = 2] = "EXACT";
    AvailableDevicesValueTypes[AvailableDevicesValueTypes["OMNI"] = 3] = "OMNI";
})(AvailableDevicesValueTypes || (AvailableDevicesValueTypes = {}));
